// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
import VeeValidate from 'vee-validate'
import Velocity from 'velocity-animate'
import VueLazyload from 'vue-lazyload'
import loading from './assets/icons/loading.gif'
import { Row, Col, Breadcrumb, BreadcrumbItem, Pagination, Icon, Collapse, CollapseItem, } from 'element-ui'

import './utils/some-other'
import 'animate.css'
import './styles/common.scss'

Vue.config.productionTip = false

Vue.use(VueLazyload, {
  loading: loading
})
Vue.use(Row);
Vue.use(Col);
Vue.use(Breadcrumb);
Vue.use(BreadcrumbItem);
Vue.use(Pagination);
Vue.use(Icon);
Vue.use(Collapse);
Vue.use(CollapseItem);
Vue.use(VeeValidate)
Vue.use(Velocity)

// Google Analytics configuration
function gtag() {
  window.dataLayer.push(arguments);
}

router.afterEach((to, from) => {
  gtag('config', 'G-EZ3T2BNDBT', { 'page_path': to.fullPath });
});

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js